import classnames from 'classnames';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

import styles from './ButtonLink.module.scss';
import { ButtonLinkProps } from './ButtonLink.types';

export const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  (
    {
      variant = 'primary',
      size = 'xlarge',
      rounded,
      selected: focus,
      className,
      disabled,
      to,
      draggable,
      onClick,
      onKeyUp,
      ...props
    },
    ref
  ) => (
    <Link
      data-icon-size={size === 'small' ? 'small' : 'medium'}
      className={classnames(styles.button, className, styles[variant], styles[size], {
        [styles.disabled]: disabled,
        [styles.rounded]: rounded,
        [styles.selected]: focus,
      })}
      role="button"
      tabIndex={disabled ? -1 : undefined}
      to={disabled ? 'javascript:void(0)' : to}
      onKeyUp={event => {
        if (event.key === 'Enter') {
          if (disabled) return event.preventDefault();
          if (!to) event.preventDefault();
          onKeyUp?.(event);
        }
      }}
      onClick={event => {
        if (disabled) return event.preventDefault();
        if (!to) event.preventDefault();
        const target = event.target as HTMLElement;
        if (
          target.matches(
            `button:not([data-role='tr']), button:not([data-role='tr']) *, a:not([data-role='tr']):not(.${styles.button}), a:not([data-role='tr']):not(.${styles.button}) *`
          )
        )
          return event.preventDefault();
        onClick?.(event);
      }}
      draggable={disabled ? false : draggable}
      {...props}
      ref={ref}
    />
  )
);
